import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpareParts = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M27.5 25.675L17.5 8.35M27.5 34.325L17.5 51.65M30 55V50M30 50C41.0457 50 50 41.0457 50 30C50 18.9543 41.0457 10 30 10M30 50C18.9543 50 10 41.0457 10 30M30 5V10M30 10C18.9543 10 10 18.9543 10 30M35 30H55M35 30C35 32.7614 32.7614 35 30 35C27.2386 35 25 32.7614 25 30C25 27.2386 27.2386 25 30 25C32.7614 25 35 27.2386 35 30ZM42.5 51.65L40 47.325M42.5 8.35L40 12.675M5 30H10M51.65 42.5L47.325 40M51.65 17.5L47.325 20M8.35 42.5L12.675 40M8.35 17.5L12.675 20",
		stroke: "#0A3C93",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSpareParts;
